import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import './LoginPage.css';

export default function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect({
      ...loginRequest,
      extraQueryParameters: {
        domain_hint: 'podoanalysis.onmicrosoft.com',
      }
    }).catch((e) => {
      console.error('loginRedirect failed:', e);
      alert('Connexion impossible : ' + (e?.errorMessage || e?.message || e));
    });
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <span className="logo-badge">PA</span>
          <span className="logo-text">PODO<br/>ANALYSIS</span>
        </div>
        <h1 className="login-title">Bienvenue</h1>
        <p className="login-sub">Connectez-vous pour accéder à votre espace podologue</p>
        <button className="btn-login" onClick={handleLogin}>
          Se connecter / S'inscrire
        </button>
      </div>
    </div>
  );
}
